import { ErrorAPI } from 'api/Associado/methods';
import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { WSO2AuthLocalStorageNames } from 'enuns/WSO2AuthLocalStorageNames';
import { getAssembleiasAssessorEndpoint } from "library/Apis";
import { Dispatch } from "redux";
import ApiService from "services/ApiService";
import { getProfileByJWTRoles } from "utils/AuthUtils";
import { toRequest } from "utils/RequestUtils";
import { getParsedJWTAssessorAccessToken, getParsedJWTAssociadoAccessToken, JWTAssessorJson, JWTAssociadoJson } from './../../utils/JWTUtils';
import { IAuthUserPerfil } from "./auth/IAuthUserPerfil";
import PerfilAssociado from './auth/PerfilAssociado';
import { AUTH_ACTIONS_LOGIN, AUTH_ACTIONS_LOGOUT, AUTH_ACTIONS_REGISTER_REDIRECT_PATH, IAuthActionsLogout, IAuthActionsRegisterRedirectPath } from "./AuthActionTypes";
import { IAuthByToken, IAuthUserReducer } from "./AuthReducer";

export function authActionsRegisterRedirectPath(
  path: string | undefined
): IAuthActionsRegisterRedirectPath {
  return {
    type: AUTH_ACTIONS_REGISTER_REDIRECT_PATH,
    payload: path,
  };
}

export const authActionsLogin = (
  accessToken: string,
  callbackSuccess?: (user: IAuthUserReducer) => void,
  callbackError?: Function
) => {
  return (dispatch: Dispatch) => {
    const parsedToken: JWTAssociadoJson | null = getParsedJWTAssociadoAccessToken(
      accessToken
    );
    const perfil: IAuthUserPerfil = PerfilAssociado;
    if (perfil && parsedToken) {
      try {
        const payload: IAuthUserReducer = {
          nome: parsedToken.name || '',
          cpfCnpj: parsedToken.preferred_username,
          perfil,
          associadoAccessToken: accessToken,
        };
        dispatch({
          type: AUTH_ACTIONS_LOGIN,
          payload,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(payload);
        }
      } catch (error) {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    } else {
      if (typeof callbackError === 'function') {
        callbackError();
      }
    }
  };
};

export function authActionsLogout(): IAuthActionsLogout {
  return {
    type: AUTH_ACTIONS_LOGOUT,
    payload: undefined,
  };
}


export const authActionsLoginByToken = (
  accessToken: string,
  idToken: string,
  callbackSuccess?: (user: IAuthUserReducer) => void,
  callbackError?: (error: AxiosError | null) => void
) => {
  return (dispatch: Dispatch<any>) => {
    const parsedToken: JWTAssessorJson | null = getParsedJWTAssessorAccessToken(
      accessToken
    );
    const perfil: IAuthUserPerfil | null = parsedToken
      ? getProfileByJWTRoles(parsedToken.role)
      : null;
    if (perfil) {
      new Promise(
        (
          resolve: (data: IAuthUserReducer) => void,
          reject: (error: AxiosError | null) => void
        ) => {
          toRequest(
            ApiService.get,
            [
              `${getAssembleiasAssessorEndpoint()}token/`,
              {
                headers: {
                  Authorization: accessToken,
                },
              } as AxiosRequestConfig,
            ],
            'usuarioToken'
          ).then(
            (resp: AxiosResponse<IAuthByToken>) => {
              const response = resp.data;
              const data: IAuthUserReducer = {
                nome: response.nome,
                cpfCnpj: response.ldap,
                ladpAccessToken: accessToken,
                coops: response.coops,
                perfil: perfil,
                tokenWs: response.tokenWs,
              };
              window.localStorage.setItem(
                WSO2AuthLocalStorageNames.AccessToken,
                accessToken
              );
              window.localStorage.setItem(
                WSO2AuthLocalStorageNames.IdToken,
                idToken
              );
              dispatch({
                type: AUTH_ACTIONS_LOGIN,
                payload: data,
              });
              resolve(data);
            },
            (error: AxiosError<ErrorAPI>) => {
              reject(error);
            }
          );
        }
      ).then(
        (data: any) => {
          if (typeof callbackSuccess === 'function') {
            callbackSuccess(data);
          }
        },
        error => {
          if (typeof callbackError === 'function') {
            callbackError(error);
          }
        }
      );
    } else {
      // quando o usuário não possui nenhum dos roles aceitos pela aplicação
      if (typeof callbackError === 'function') {
        callbackError(null);
      }
    }
  };
};
